import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import _ from 'lodash';
import { Customer } from 'app/core/model/entity-model';

@Component({
    selector: 'app-customer-add-dialog',
    templateUrl: './customer-add-dialog.component.html',
    styleUrls: ['./customer-add-dialog.component.scss'],
    standalone: false
})
export class CustomerAddDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    customer: Customer;
    states: any;
    countries = ['US', 'OTHER'];
    // showCopyBilling = false;
    // showAddressSelect = false;
    // addresses: any[];
    // selectedAddress: any;

    constructor(private uow: GenesisUnitOfWork, public modalRef: BsModalRef, protected appInfo: AppInformationService) {}

    async ngOnInit() {
        this.states = this.uow.lookups.states;

        if (!this.customer) {
            this.customer = this.uow.customers.createEntity() as Customer;
            this.customer.billState = 'MI';
            this.customer.billCountry = 'US';
        }
    }

    async save() {
        await this.uow.commit([this.customer]);
        this.result.next({ result: true, customerId: this.customer.id });
    }

    cancel() {
        this.customer.entityAspect.rejectChanges();
        this.result.next({ result: false });
    }
}
